import { Button } from 'design-system';
import { UserRoundCog } from 'lucide-react';

import { storage, StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { redirectTo } from '@/shared/lib/url/navigation';
import { useAppSelector } from '@/store/hooks';

const exitImpostorMode = () => {
  const cached = storage.get(StorageKeys.CachedToken);
  if (storage.get(StorageKeys.GxToken) && cached) {
    storage.set(StorageKeys.GxToken, cached);
    storage.remove(StorageKeys.TripToken);
    storage.remove(StorageKeys.CachedToken);
    storage.remove(StorageKeys.Impersonator);
  }
};

export const ImpersonatorBanner = () => {
  const handleExitImpersonatorMode = () => {
    exitImpostorMode();
    redirectTo('/');
  };
  const impersonatorEmail = useStorageValue(StorageKeys.Impersonator);

  const tripTokenState = useAppSelector(state => state.tripToken);

  if (!impersonatorEmail) return null;
  return (
    <div className='mb-6 flex w-full justify-between gap-6'>
      <div className='flex h-12 w-full items-center justify-center bg-gx-highlight px-4'>
        <p>
          You are logged in as <strong>{tripTokenState.userEmail}</strong>
        </p>
        <Button
          className='ml-6 h-8 w-[120px] bg-gx-action-bar-button-tile px-1 text-xs text-gx-text hover:bg-gx-action-bar-button-tile/80'
          size='sm'
          onClick={handleExitImpersonatorMode}
        >
          <UserRoundCog className='size-[18px]' /> Switch back
        </Button>
      </div>
    </div>
  );
};
